module.exports = __webpack_public_path__ + "media/cloth_4.bc565e66.mp3";